export default __webpack_public_path__ + "static/media/pattern1a.2d05fc28.svg";